module.exports = __webpack_public_path__ + "static/media/ic_warning.af6f92e1.svg";